import { Injectable } from "@angular/core";
import { CanActivate, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserService } from "./user.service";

@Injectable({ providedIn: 'root' })
export class CatalogManagerGuard implements CanActivate {

    constructor(private userService: UserService) {}

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.userService.isLoggedIn()
        .pipe(map(status => !!status.user?.tenantRoleActions.find(roleActions => roleActions?.roleName === 'TENANT_ADMIN' && roleActions?.actions?.includes('MANAGE_CATALOG'))))
    }
}